import React, { useMemo, useState } from 'react';
import { H3 } from 'tea-component';
import BubbleCommon from '@/pages/opinion/components/BubbleCommon';
import { engagementText } from '@/pages/opinion/components/BubbleCommon/copywritingKey/community';
import CardCommon from '@/pages/opinion/components/CardCommon';
import { useIntl } from 'umi';
import { barIcon, lineIcon } from '@/pages/opinion/constants/chart';
import CommunityChart from '@op/pages/community/video/components/VideoCard/chart';
import VideoDownload from '@op/pages/community/video/components/VideoDownload';

export default function OpinionsVideoChart({
  type = 'counts',
  keepParams = {},
  gameInfo = {},
  data,
  loading,
}: any) {
  const { formatMessage } = useIntl();
  const [visible, setVisible] = useState(false);
  const { title } = useMemo(() => {
    const cardMap: any = {
      counts: {
        title: formatMessage({ id: 'Video Counts' }),
      },
      engagements: {
        pureTitle: 'Video Engagement',
        title: (
          <div style={{ display: 'flex' }}>
            {formatMessage({ id: 'Video Engagement' })}
            <BubbleCommon
              tipsMap={engagementText}
              className="title-icon"
              placement="top"
              iconStyle={{ marginLeft: 6 }}
            ></BubbleCommon>
          </div>
        ),
      },
      views: {
        title: formatMessage({ id: 'Video Views' }),
      },
    };
    return cardMap[type];
  }, [type, formatMessage]);

  const [engagementType, setEngagementType] = useState('engagements');
  const metrics = useMemo(() => {
    return [type === 'engagements' ? engagementType : type];
  }, [engagementType]);

  const engagementTypeOptions = [
    {
      text: formatMessage({ id: 'Engagement' }),
      value: 'engagements',
    },
    {
      text: formatMessage({ id: 'Likes' }),
      value: 'likes',
    },
    {
      text: formatMessage({ id: 'Comments' }),
      value: 'comments',
    },
    {
      text: formatMessage({ id: 'Shares' }),
      value: 'shares',
    },
  ];

  const [engagementTypeText, setEngagementTypeText] = useState('Engagement');

  const [chartType, setChartType] = useState('bar');

  return (
    <>
      <CardCommon
        title={<H3 style={{ marginRight: 15 }}>{title}</H3>}
        className={`video-card-item ${type === 'engagement' ? 'engagement-title' : ''}`}
        hasDownload
        operations={[barIcon, lineIcon]}
        handleOperationsOnClick={({ symbol }) => setChartType(symbol)}
        filters={type === 'engagements' ? engagementTypeOptions : []}
        handleDownloadOnClick={() => setVisible(true)}
        handleFilterOnChange={(value) => {
          setEngagementType(value);
          setEngagementTypeText(
            engagementTypeOptions.find((item) => item.value === value)?.text ||
            'Engagement',
          );
        }}
      >
        <>
          <CommunityChart
            chartType={chartType}
            statistics={data.statistics}
            type={type}
            loading={loading}
            keepParams={keepParams}
            engagementTypeText={engagementTypeText}
          ></CommunityChart>
          <VideoDownload
            visible={visible}
            filter={keepParams}
            setVisible={setVisible}
            gameInfo={gameInfo}
            type={type}
            defaultSelect={metrics}
            checkboxList={
              [
                { text: 'Video Counts', value: 'counts' },
                { text: 'Views', value: 'views' },
              ]?.filter(item => item?.value === type)
            }
          ></VideoDownload>
        </>
      </CardCommon>
    </>
  );
}
